import React from 'react';
import { Grid2, Typography, Box } from '@mui/material';
import { AddonCard } from 'components'; // Assuming AddonCard is properly typed and exported
import { AncillaryData } from 'types'; // Assuming the types are defined in interfaces.ts
import { RentalRate } from 'types/BookingDetails';
interface Ancillary {
  AncillaryID: string;
  Qty: number;
}
interface AncillaryCardProps {
  ancillaryData: RentalRate[] | null;
  onSelect?: (ChargeCode: string, chargeCodeType: number) => void;
}

export const AncillaryCard: React.FC<AncillaryCardProps> = ({
  ancillaryData,
  onSelect,
}) => {
  const ANCILARIES = ['COT', 'VRF', 'ADR'];
  const isAncillaryChecked = (
    ancillaries: Ancillary[] | undefined,
    id: string
  ) => {
    return ancillaries && ancillaries.some((item) => item.AncillaryID === id);
  };
  return (
    <Box className="box-container-layout">
      <Typography
        color="primary"
        sx={{ textAlign: 'start', marginBottom: '40px', fontWeight: 'normal' }}
      >
        Choose your{' '}
        <span style={{ textDecoration: 'underline', fontWeight: '600' }}>
          Add-Ons
        </span>
      </Typography>
      <Grid2 container spacing={2}>
        {ancillaryData &&
          ancillaryData.map(
            (ancillary, index) =>
              ANCILARIES.includes(ancillary.Code) && (
                <Grid2 size={{ sm: 6 }} key={index}>
                  <AddonCard
                    id={ancillary.Code}
                    title={ancillary.Name}
                    description={ancillary.Description}
                    price={ancillary.TotalAmt}
                    numberOfDays={ancillary.Duration}
                    isChecked={
                      ancillary.IsCompulsory
                        ? ancillary.IsCompulsory
                        : ancillary.IsSelected
                    }
                    onCheck={() => onSelect && onSelect(ancillary.Code, 1)}
                    isCompulsoryOnRental={ancillary.IsCompulsory}
                  />
                </Grid2>
              )
          )}
      </Grid2>
    </Box>
  );
};
